import { Component } from '@angular/core';

@Component({
    selector: 'app-back-panel',
    templateUrl: './back-panel.component.html',
    styleUrls: ['./back-panel.component.scss'],
    standalone: false
})
export class BackPanelComponent {

}
